module.exports = __webpack_public_path__ + "media/entities/1101-60bd1ce3.png";